module.exports = __webpack_public_path__ + "img/20_minutos.908983dd.svg";